import React from "react";

const SectionHeader = ({ num, title, subtitle }) => (
  <div className="mb-10 md:mb-14">
    <div className="flex items-center gap-4 mb-3">
      <span className="font-mono text-cyan-400 text-xs tracking-[0.25em]">{num}</span>
      <span className="h-px flex-1 bg-gradient-to-r from-cyan-400/60 to-transparent" />
    </div>
    <h2 className="font-mono font-bold text-3xl md:text-4xl tracking-tight text-slate-50">
      {title}
    </h2>
    {subtitle && (
      <p className="font-mono text-[11px] tracking-[0.2em] text-slate-500 mt-2">{subtitle}</p>
    )}
  </div>
);

export default SectionHeader;
